interface CardItem {
  icon: string;
  title: string;
  desc: string;
  tag: string;
  img: string;
  alt: string;
}

const cards: CardItem[] = [
  {
    icon: 'ri-movie-2-line',
    title: '热门电影',
    desc: '院线大片、经典佳作、动作科幻喜剧全覆盖，高清画质即点即看，每周更新最新上映资源。',
    tag: '2,300+ 部',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20atmosphere%20with%20warm%20golden%20amber%20lighting%2C%20abstract%20film%20projector%20light%20beam%20on%20dark%20background%2C%20soft%20bokeh%20effects%2C%20elegant%20cinema%20aesthetic%2C%20minimalist%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=card-movie-01&orientation=landscape',
    alt: '热门电影',
  },
  {
    icon: 'ri-tv-2-line',
    title: '最新剧集',
    desc: '国产剧、韩剧、美剧、日剧同步追更，完整版全集一次看够，告别追剧等待焦虑。',
    tag: '1,800+ 部',
    img: 'https://readdy.ai/api/search-image?query=Modern%20cozy%20living%20room%20with%20warm%20lighting%20and%20streaming%20device%20glow%2C%20abstract%20digital%20entertainment%20concept%2C%20soft%20orange%20and%20amber%20tones%2C%20cinematic%20composition%2C%20minimalist%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=card-drama-02&orientation=landscape',
    alt: '最新剧集',
  },
  {
    icon: 'ri-emotion-laugh-line',
    title: '综艺精选',
    desc: '热门综艺、真人秀、脱口秀一网打尽，搞笑治愈陪伴每一天，热门综艺每周同步。',
    tag: '900+ 部',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20colorful%20stage%20lighting%20with%20dynamic%20patterns%20on%20dark%20background%2C%20warm%20golden%20and%20amber%20glow%2C%20entertainment%20show%20aesthetic%2C%20vibrant%20but%20elegant%20composition%2C%20soft%20atmospheric%20effects%2C%20no%20text%20no%20people&width=800&height=500&seq=card-variety-03&orientation=landscape',
    alt: '综艺精选',
  },
  {
    icon: 'ri-ghost-line',
    title: '动漫专区',
    desc: '日漫国漫全年番剧不间断更新，热血、治愈、悬疑各类题材，追番党的一站式乐园。',
    tag: '1,500+ 部',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20anime%20style%20composition%20with%20warm%20golden%20orange%20energy%20waves%20on%20dark%20background%2C%20dynamic%20light%20flow%20and%20sparkle%20effects%2C%20fantasy%20atmosphere%2C%20soft%20ambient%20glow%2C%20cinematic%20aesthetic%2C%20no%20text%20no%20people&width=800&height=500&seq=card-anime-04&orientation=landscape',
    alt: '动漫专区',
  },
  {
    icon: 'ri-earth-line',
    title: '纪录片库',
    desc: '自然、历史、科技、人文纪录片精选，BBC、NHK等顶级制作，拓展视野的最佳选择。',
    tag: '600+ 部',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20nature%20and%20earth%20landscape%20concept%20with%20warm%20golden%20sunlight%2C%20soft%20atmospheric%20haze%2C%20cinematic%20composition%20on%20dark%20background%2C%20elegant%20minimalist%20aesthetic%2C%20warm%20amber%20tones%2C%20no%20text%20no%20people&width=800&height=500&seq=card-doc-05&orientation=landscape',
    alt: '纪录片库',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            内容精选
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            五大内容板块，满足你的所有观影需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <article
              key={card.title}
              className={`group bg-background-50 rounded-2xl overflow-hidden border border-background-200/80 hover:border-primary-200 transition-all duration-300 ${
                i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'}`}>
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  loading={i > 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-700 backdrop-blur-sm whitespace-nowrap">
                    <i className={`${card.icon} text-primary-500`}></i>
                    {card.title}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500/90 text-background-50 whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              {i === 0 && (
                <div className="p-5">
                  <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}